import { Component, ReactNode } from "react";

interface AppErrorBoundaryState {
  error: Error | null;
}

export class AppErrorBoundary extends Component<{ children: ReactNode }, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): AppErrorBoundaryState {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <main className="grid min-h-screen place-items-center bg-ktd-black px-4 py-10 text-white">
          <section className="max-w-2xl rounded-lg border border-ktd-gold/25 bg-ktd-ivory p-8 text-ktd-rich shadow-luxe">
            <p className="text-xs font-extrabold uppercase tracking-[0.2em] text-[#8a6c14]">
              Backend Configuration Required
            </p>
            <h1 className="mt-4 font-display text-3xl font-bold">The Memory Media Vault could not connect.</h1>
            <p className="mt-4 text-sm font-semibold leading-6 text-ktd-muted">{this.state.error.message}</p>
          </section>
        </main>
      );
    }

    return this.props.children;
  }
}
